import React, { Component } from "react";
import { NavLink as RouteLink } from "react-router-dom";
import PropTypes from "prop-types";
import Header from "../../components/Header/Header";
import headerImg from "../../assets/images/backgrounds/work-731198_1920.png";
//import "../Work/Work.css";
//import "../Work/WorkDetail.css";
import "./CareerUiux.css";

class CareerUiux extends Component {
  isMobile() {
    return window.innerWidth <= 768;
  }

  render() {
    return (
      <div>
        <Header
          big_header={this.props.title}
          bgImage={headerImg}
          strength={200}
          page="uiux"
          offset={this.isMobile() ? 0 : -30}
        />
        <div name="careerUiux" className="section careerUiux container-fluid">
          <div className="row">
            <h1 className="col-12 col-lg-8 text-center text-lg-left mx-auto">
              UI / UX
            </h1>
            <p className="col-12 col-lg-8 text-center text-lg-left mx-auto section-text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
              tristique nisl non eleifend posuere. Nam mollis leo at neque
              sagittis elementum. Nullam pulvinar ut ante ut auctor. Suspendisse
              convallis, tellus vitae egestas mattis, neque magna malesuada
              lacus, vel dignissim felis elit eget odio. Vestibulum imperdiet,
              mauris maximus eleifend varius, justo lorem pretium purus, vitae
              tristique eros velit non eros. Nam rutrum tempor ligula sed
              convallis.
            </p>
          </div>
          <div className="row">
            <div className="col-10 col-md-8 col-xl-5 mx-auto text-center seeWorkContainer">
              <h3>:contactTitle:</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                tristique nisl non eleifend posuere. We are always welcoming you
                to contact us.
              </p>
              <RouteLink
                onClick={() =>
                  this.props.click_function("CareerUiux", "CareerUiux")}
                activeClassName="highlighted"
                to="/contact"
                className="btn-whiteOnWhite seeWorkButton"
              >
                Get in touch
              </RouteLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
CareerUiux.propTypes = {
  click_function: PropTypes.func,
  title: PropTypes.string
};
CareerUiux.defaultProps = {
  click_function: () => {},
  title: null
};
export default CareerUiux;



// WEBPACK FOOTER //
// ./src/routes/Career/CareerUiux.jsx